import { render, staticRenderFns } from "./RiskBlkSICheckList.vue?vue&type=template&id=47524eac&"
import script from "./RiskBlkSICheckList.vue?vue&type=script&lang=js&"
export * from "./RiskBlkSICheckList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports